import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/services/auth.service';

@Injectable()
export class PastordersRouteGuard  {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.auth.isAuthenticated()) {
      this.auth.handleAuthenticationURLEntry(state.url);
      this.router.navigate(['/account/login']);
      return false;
    }
    return true;
  }
}
